import Rive, {Layout} from "rive-react";
import React from "react";
import animation from "../../assets/img/background/Lebaran-2026.json"
import {Player} from "@lottiefiles/react-lottie-player";

const SeasonalBackground = () => {
    return (
        <div>
            <div className="hero-backgrounds landing-page">
                <div className="hero-slider-background seasonal">
                    {/* <div className="hero-lottie">
                        <Player
                            autoplay
                            loop
                            src={animation}
                            style={{ height: "100%", width: "auto" }}
                        /> */}
                    {/*STATIC BACKGROUND*/}
                        <div className="hero-background-seasonal"></div>
                    {/*RIVE FILE BACKGROUND*/}
                    {/*<Rive*/}
                    {/*    src="/lebaran_2025_-_danai.riv"*/}
                    {/*    layout={new Layout({fit: "cover", alignment: "bottomRight"})}*/}
                    {/*    className="absolute w-full h-full"*/}
                    {/*/>*/}
                </div>
                </div>
                <div className="hero">
                    <div className="hero-message-wrapper landing-page mt-12">
                        <h1>
                            <div className="baris-1">Selamat Hari<br/>Raya Idul Fitri</div>
                        </h1>
                        <h1>
                            <div className="baris-2">Mohon Maaf Lahir & Batin</div>
                        </h1>
                    </div>
                </div>
            </div>
    );
};

export default SeasonalBackground;
